/** Unit of measure options aligned with Part Master / inventory unitMetric. */
export const UNIT_METRIC_OPTIONS = [
  'EACH',
  'Liters',
  'Kilo Gram',
  'ML',
  'Semi-Kit',
  'Kit',
  'Meter',
  'Roll'
];

/** Display labels for select menus (stored values remain canonical). */
export const UNIT_METRIC_LABELS = {
  EACH: 'Each',
  Liters: 'Liters',
  'Kilo Gram': 'Kilo Gram',
  ML: 'ML',
  'Semi-Kit': 'Semi-Kit',
  Kit: 'Kit',
  Meter: 'Meter',
  Roll: 'Roll'
};

export function unitMetricLabel(value) {
  const raw = value != null ? String(value).trim() : '';
  if (!raw) return '—';
  return UNIT_METRIC_LABELS[raw] || raw;
}

/** Select options including a legacy/custom unit not in the canonical list. */
export function unitSelectOptions(currentUnit) {
  const unit = String(currentUnit || 'EACH').trim() || 'EACH';
  if (UNIT_METRIC_OPTIONS.includes(unit)) return UNIT_METRIC_OPTIONS;
  return [unit, ...UNIT_METRIC_OPTIONS];
}
